import React from "react";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { Skeleton } from "@mui/material";

/**
 * Catalogue KPI cards derived from items list (incl. hidden/retired + purchaseCount).
 */
const MarketplaceStats = ({ stats, isLoading }) => {
  const cards = [
    {
      key: "catalog",
      label: "Catalog Items",
      value: isLoading ? null : `${stats?.total ?? 0} add-ons`,
      meta: (
        <>
          <span className="meta-active">{stats?.active ?? 0} Active</span>
          {" · "}
          <span className="meta-soon">{stats?.hidden ?? 0} Hidden</span>
          {" · "}
          <span className="meta-disabled">{stats?.retired ?? 0} Retired</span>
        </>
      ),
      iconClass: "is-blue",
      Icon: ShoppingBagOutlinedIcon,
    },
    {
      key: "active",
      label: "Selling Now",
      value: isLoading ? null : `${stats?.active ?? 0} active`,
      meta: "ACTIVE items that sell and renew",
      iconClass: "is-green",
      Icon: ShoppingCartOutlinedIcon,
    },
    {
      key: "hidden",
      label: "Hidden from Store",
      value: isLoading ? null : `${stats?.hidden ?? 0} hidden`,
      meta: "Stops new sales; existing renewals continue",
      iconClass: "is-purple",
      Icon: VisibilityOffOutlinedIcon,
    },
    {
      key: "purchases",
      label: "Lifetime Purchases",
      value: isLoading ? null : `${stats?.purchases ?? 0}`,
      meta: "Sum of purchaseCount across catalogue",
      iconClass: "is-red",
      Icon: BlockOutlinedIcon,
    },
  ];

  return (
    <div className="row g-3 mb-4">
      {cards.map(({ key, label, value, meta, iconClass, Icon }) => (
        <div key={key} className="col-12 col-md-6 col-xl-3">
          <div className="marketplace-stat-card">
            <div className={`stat-icon ${iconClass}`}>
              <Icon fontSize="small" />
            </div>
            <div className="flex-grow-1">
              <div className="stat-label">{label}</div>
              <div className="stat-value">
                {value == null ? <Skeleton width={120} height={28} /> : value}
              </div>
              <div className="stat-meta">{meta}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MarketplaceStats;
